<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :createRoute="{
                    name: 'activation.create',
                    params: {
                        category_id: categoryId,
                    },
                }"
                :resourceName="$tc('resources.activation.name', 1)"
                :query="categoryFilter"
                ref="table"
            >
                <template #value="{ item }">
                    {{ $n(item.value, 'currency') }}
                </template>

                <template #amount="{ item }">
                    {{ item.amount ? item.amount : '-' }}
                </template>

                <template #action="{ item }">
                    <edit-btn
                        :to="{
                            name: 'activation.edit',
                            params: { id: item.id, category_id: categoryId },
                        }"
                    />

                    <delete-btn @click="deleteItem(item)" />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Activation from '@/models/Activation'
export default {
    props: ['categoryId'],

    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new Activation()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                `de ${this.$tc('resources.activation.name', 1).toLowerCase()}`,
            )
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.activation.name', 1),
                }),
            )
        },

        categoryFilter(model) {
            model.where('category_id', this.categoryId)
        },
    },
}
</script>

<style></style>
